function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-642 -80) translate(0 64) translate(642 16)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H16V16H0z",
  transform: "translate(-642 -80) translate(0 64) translate(642 16) translate(8 8)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 15h-8C1.57 15 0 13.43 0 11.5v-8C0 1.57 1.57 0 3.5 0h8C13.43 0 15 1.57 15 3.5v8c0 1.93-1.57 3.5-3.5 3.5zm-8-14C2.122 1 1 2.122 1 3.5v8C1 12.879 2.122 14 3.5 14h8c1.379 0 2.5-1.121 2.5-2.5v-8C14 2.122 12.879 1 11.5 1h-8z",
  transform: "translate(-642 -80) translate(0 64) translate(642 16) translate(8 8) translate(.5 .5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 5.5H11V6.5H4zM4 8.5H11V9.5H4z",
  transform: "translate(-642 -80) translate(0 64) translate(642 16) translate(8 8) translate(.5 .5)"
})))))));

var SvgWhiteAmount = function SvgWhiteAmount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteAmount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white_amount.5ed9189c.svg";
export { ForwardRef as ReactComponent };